export default __webpack_public_path__ + "static/pureplank-17de5fffa920fe3e4c1a18a24c58e9ec.webp";